import Vue from 'vue'
import App from './App.vue'
//引入axios



//引入VouRouter
import VueRouter from 'vue-router'
//引入路由器
import router from './router'
//引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//导入富文本
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import VueParticles from 'vue-particles'

Vue.use(VueParticles)
Vue.use(VueQuillEditor)
Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(ElementUI);

new Vue({
	render: h => h(App),
	router: router
}).$mount('#app')
